import { mutatorAction } from "satcheljs";
import getListViewState from "../selectors/getListViewState";

export const onAutoOpenJumpToMutator: () => void = mutatorAction("onAutoOpenJumpToMutator", (): void => {
    const listViewState = getListViewState();
    
    listViewState.shouldAutoOpenJumpTo = false;
    listViewState.isFocusWithinJumpTo = true;
});
